module.exports = __webpack_public_path__ + "media/images/landing_page/digweddash4-6925ad02981ace9186f77bd73f204f27.png";